<template>
    <div>
        <div class="pagination-2  mb-3">
            
            <div class="pagination-2__btn  pagination-2__btn--prev" :class="{' pagination-2__btn--disabled': currentPriority <= 1}">
                <a @click="prevQuestion" class="exam__back-btn  btn  btn--with-icon" href="javascript:void(0)">
                    <svg class="btn__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.56 10.5H4.916l7.622-7.94a1.545 1.545 0 0 0 0-2.12 1.4 1.4 0 0 0-2.036 0L.422 10.94a1.545 1.545 0 0 0 0 2.12l10.08 10.5c.28.293.65.44 1.018.44s.737-.147 1.018-.44a1.544 1.544 0 0 0 0-2.12L4.916 13.5H22.56c.795 0 1.44-.672 1.44-1.5s-.645-1.5-1.44-1.5z">
                        </path>
                    </svg>
                    {{ getTranslation('previousQuestion') }}
                </a>
            </div>
            
            <div><span class="color-main"><b>{{ currentPriority }}</b></span> {{ getTranslation('questionOf',questions.length) }}</div>
            
            <div class="pagination-2__btn  pagination-2__btn--next">
                <a :class="{'pagination-2__btn--disabled': !nextQ && currentPriority >= questions.length}" @click="nextQuestion" class="btn  btn--with-icon" href="javascript:void(0)">
                    {{ getTranslation('nextQuestion') }}
                    <svg class="btn__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.428 13.5h17.696l-7.559 7.94a1.554 1.554 0 0 0 0 2.12 1.38 1.38 0 0 0 2.02 0l9.997-10.5a1.554 1.554 0 0 0 0-2.12L13.585.44a1.39 1.39 0 0 0-1.01-.44c-.365 0-.73.147-1.01.44a1.554 1.554 0 0 0 0 2.12l7.56 7.94H1.427C.64 10.5 0 11.172 0 12c0 .829.64 1.5 1.428 1.5z" />
                    </svg>
                </a>
            </div>
        
        </div>
    </div>
</template>

<script>
    export default {
        name: "QuestionPaginationComponent",
        props: {
            questions: {
                type: Array,
                required: false,
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                nextQ: true,
                prevQ: false,
            }
        },
        created() {
            this.$store.dispatch( 'candidate/setQuestionCount', this.questions.length );
            this.$store.dispatch( 'candidate/setCurrentQuestionNo', this.currentPriority || 1 );
        },
        computed: {
            currentPriority() {
                return parseInt( this.$route.query.question ) || 1;
            }
        },
        watch: {
            'currentPriority'( val ) {
                if ( val ) {
                    this.$store.dispatch( 'candidate/setCurrentQuestionNo', val );
                    if ( val >= this.questions.length )
                        this.nextQ = false;
                }
            }
        },
        methods: {
            nextQuestion() {
                let maxId = this.questions.length;
                
                if ( ( this.currentPriority + 1 ) > maxId || maxId === this.currentPriority ) {
                    this.nextQ = false;
                }
                else {
                    this.$router.push( { query: { question: ( this.currentPriority + 1 ) } } ).then( () => {
                    } ).catch( () => {
                    } );
                    this.nextQ = true;
                }
            },
            prevQuestion() {
                if ( this.currentPriority > 1 ) {
                    this.$router.push( { query: { question: ( this.currentPriority - 1 ) } } ).catch( () => {
                    } );
                }
            }
        }
    }
</script>

<style scoped>

</style>
